import { Avatar, Dropdown } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/useAuthStore';
import { useQueryClient } from '@tanstack/react-query';

export const UserDropdown = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const queryClient = useQueryClient();
  const clearAuth = useAuthStore((state) => state.clearAuth);

  const handleMenuClick = async ({ key }) => {
    switch (key) {
      // case 'settings':
      //   navigate('/dashboard/settings');
      //   break;
      case 'logout':
        await queryClient.clear();
        queryClient.removeQueries();
        clearAuth();
        navigate('/');
        break;
      default:
        break;
    }
  };

  // Get initials for Avatar
  const getInitials = () => {
    if (user?.fname && user?.lname) {
      return `${user.fname.charAt(0)}${user.lname.charAt(0)}`.toUpperCase();
    }
    if (user?.fname) {
      return user.fname.charAt(0).toUpperCase();
    }
    return null;
  };

  const menuItems = [
    {
      key: 'profile',
      label: (
        <div className="flex items-center gap-3 px-3 py-2">
          <Avatar src={user?.profilePicture || '/usersPic.svg'} size={36}>
            {getInitials()}
          </Avatar>
          <div className="flex flex-col min-w-0">
            {(user?.fname || user?.lname) && (
              <span className="font-semibold text-gray-900 text-sm truncate">
                {user?.fname} {user?.lname}
              </span>
            )}
            <span className="text-gray-500 text-xs truncate">
              {user?.email || user?.contactPersonEmailAddress}
            </span>
            {user?.role && (
              <span className="text-gray-400 text-[11px] mt-0.5 truncate">
                {user?.role?.replace(/_/g, ' ').toLowerCase()}
              </span>
            )}
          </div>
        </div>
      ),
      disabled: true,
      style: { cursor: 'default', background: 'transparent', padding: 0 },
    },
    // {
    //   key: 'settings',
    //   label: 'My Settings',
    // },
    { type: 'divider' },
    {
      key: 'logout',
      label: (
        <span className="block w-full text-left text-red-500 font-medium text-sm px-3 py-2 hover:bg-gray-50 transition-colors cursor-pointer">
          Log Out
        </span>
      ),
      style: { padding: 0 },
    },
  ];

  return (
    <Dropdown
      menu={{ items: menuItems, onClick: handleMenuClick }}
      trigger={['click']}
      placement="bottomRight"
      overlayClassName="user-dropdown-menu"
      popupRender={(menu) => (
        <div className="bg-white p-0 min-w-[220px]">{menu}</div>
      )}
    >
      <Avatar
        icon={!getInitials() && <UserOutlined />}
        src={user?.profilePicture || '/usersPic.svg'}
        style={{
          cursor: 'pointer',
        }}
        size={36}
      >
        {getInitials()}
      </Avatar>
    </Dropdown>
  );
};
